import React from "react";
import PropTypes from "prop-types";

import classNames from "classnames";
import styles from "./Icons.module.scss";

export const Navigation = ({ className, color }) => {

    const cx = classNames.bind(styles);

    const classes = cx(
        "wrapper",
        className
    );

    return (
        <svg className={classes} xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26">
            <rect data-name="Rectangle 1" width="26" height="15" fill={color} />
            <rect data-name="Rectangle 2" width="26" height="3" transform="translate(0 23)" fill={color} />
            <rect data-name="Rectangle 3" width="26" height="4" transform="translate(0 17)" fill={color} />
        </svg>
    );
};
    
Navigation.propTypes = {
    className: PropTypes.string,
    color: PropTypes.string
};

Navigation.defaultProps = {
    color: "#fff"
};